"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _MultipleChoiceFilter = _interopRequireDefault(require("../MultipleChoiceFilter"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["presets", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * returns selected preset.
 * The preset is set to be selected,
 * if all the available items by that preset categoty is selected
 * and nothing is selected from different categories
 * @param {*} items
 * @param {*} presets
 */
var findSelectedCategory = function findSelectedCategory(items, presets) {
  var activeItems = items.filter(function (item) {
    return !item.disabled;
  });
  var selectedItems = activeItems.filter(function (item) {
    return item.selected;
  });
  var selectedCategories = presets.reduce(function (res, _ref) {
    var id = _ref.id,
      field = _ref.field;
    var isActive = !(0, _isEmpty2["default"])(selectedItems) && selectedItems.every(function (item) {
      return item[field] === id;
    }) && selectedItems.length === activeItems.filter(function (item) {
      return item[field] === id;
    }).length;
    if (isActive) {
      res.push(id);
    }
    return res;
  }, []);
  return selectedCategories.length === 1 ? selectedCategories[0] : null;
};
var FilterWithPreset = function FilterWithPreset(_ref2) {
  var presets = _ref2.presets,
    className = _ref2.className,
    filterProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var items = filterProps.items,
    isMobile = filterProps.isMobile,
    onChange = filterProps.onChange;
  (0, _react.useEffect)(function () {
    return setActive(findSelectedCategory(items, presets));
  }, [items, presets]);
  var handleClick = function handleClick(_ref3) {
    var id = _ref3.id,
      field = _ref3.field;
    if (active === id) {
      var newItems = items.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          selected: false
        });
      });
      setActive(null);
      onChange(newItems);
    } else {
      var _newItems = items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          selected: item[field] === id && !item.disabled
        });
      });
      setActive(id);
      onChange(_newItems);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledFilterWithPreset, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledPresetContainer, {
    isMobile: isMobile
  }, presets.map(function (_ref4) {
    var id = _ref4.id,
      label = _ref4.label,
      field = _ref4.field;
    return /*#__PURE__*/_react["default"].createElement(StyledPresetButton, {
      key: id,
      disabled: items.filter(function (item) {
        return item[field] === id;
      }).every(function (item) {
        return item.disabled;
      }),
      isActive: active === id,
      onClick: function onClick() {
        return handleClick({
          id: id,
          field: field
        });
      }
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(_MultipleChoiceFilter["default"], filterProps));
};
var StyledPresetButton = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "FilterWithPreset__StyledPresetButton",
  componentId: "sc-1j8xv8l-0"
})(["background:none;width:auto;height:22px;padding:0 5px;font-size:14px;border-radius:2px;border:solid 1px;margin-right:5px;line-height:16px;border-color:", ";color:", ";", " ", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blackLight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blackBase;
}, function (_ref7) {
  var isActive = _ref7.isActive,
    theme = _ref7.theme;
  return isActive && (0, _styledComponents.css)(["", ";color:", ";border-color:transparent;"], theme.gradient.darkBlueToLight(), theme.colors.white);
}, function (_ref8) {
  var disabled = _ref8.disabled,
    theme = _ref8.theme;
  return disabled && (0, _styledComponents.css)(["color:", ";border-color:", ";"], theme.colors.frenchGray, theme.colors.greyLight);
});
var StyledPresetContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterWithPreset__StyledPresetContainer",
  componentId: "sc-1j8xv8l-1"
})(["margin-bottom:10px;", ""], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile && (0, _styledComponents.css)(["margin-left:10px;", "{font-size:17px;height:38px;}"], StyledPresetButton);
});
FilterWithPreset.propTypes = {
  className: _propTypes["default"].string,
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    field: _propTypes["default"].string.isRequired
  })).isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  visibleItems: _propTypes["default"].number,
  expandLabel: _propTypes["default"].string,
  LabelComponent: _propTypes["default"].func,
  isMobile: _propTypes["default"].bool,
  currencyCode: _propTypes["default"].string
};
FilterWithPreset.defaultProps = {
  className: '',
  visibleItems: Infinity,
  expandLabel: 'Показать все',
  LabelComponent: undefined,
  isMobile: false
};
var StyledFilterWithPreset = _styledComponents["default"].div.withConfig({
  displayName: "FilterWithPreset__StyledFilterWithPreset",
  componentId: "sc-1j8xv8l-2"
})([""]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FilterWithPreset);